
    var riot = require('riot')
    //src: starling/src/tags/node-eyeball.html
riot.tag2('node-eyeball',
  '<button ref="button" class="eyeball-container {this.activeClass()}" onclick="{handleClick}" ondblclick="{handleClick}" onmouseenter="{showEyebeams}" onmouseleave="{hideEyebeams}" oncontextmenu="{handleRightClick}" if="{this.showPerspectivePoint()}"> <i ref="eyeball" class="material-icons point" riot-style="color: {this.getPointColor()}">visibility</i> <i if="{!opts.dummy && this.needsBacking()}" class="material-icons point point-backing">visibility</i> </button>',
  'node-eyeball button,[data-is="node-eyeball"] button{ pointer-events: auto; padding: 0; border: none; background: none; top: -2px; margin: 0 3px 0 2px; position: relative; } node-eyeball .point,[data-is="node-eyeball"] .point{ vertical-align: middle; margin: 2px 0; cursor: pointer; user-select: none; line-height: 0; } node-eyeball .point-backing,[data-is="node-eyeball"] .point-backing{ color: white; position: absolute; top: 6px; left: 0px; z-index: -1; text-shadow: -2px -2px 0 #fff, 2px -2px 0 #fff, -2px 2px 0 #fff, 2px 2px 0 #fff, 3px 0px #fff, -3px 0px #fff, 0px 3px #fff, 0px -3px #fff } node-eyeball .active > .point,[data-is="node-eyeball"] .active > .point,node-eyeball .active > .point-backing,[data-is="node-eyeball"] .active > .point-backing{ transform: scale(1.5); }',
  '', function(opts) {
'use strict';

var _this = this;

var _constants = require('lib/constants');

this.preview = false;
this.canvas = this.parent.canvas;
this.nodeTag = this.parent;

this.handleClick = function (e) {
  if (_this.canvas.linkDragging) return;
  e.stopPropagation();
  e.stopImmediatePropagation();
  var p = _this.pointPerspective;
  if (pui.perspectiveIsPersistent(p.id)) {

    // if we're clicking on an active & persistent perspective, then unselect it
    pui.unsetActivePerspective(p);
  } else {

    // otherwise, if no other P is active, then this to active
    if (!pui.getPersistentPerspectiveCount()) {

      pui.setActivePerspective(p, true);
    } else {

      // if one or more P's are active, add this one in
      pui.setMultipleActivePerspective(p, true);
    }
    _this.showEyebeams();
  }
  _this.update();
};

this.pointIsActive = function () {
  if (_this.pointPerspective && pui.perspectiveIsPersistent(_this.pointPerspective.id)) {
    return true;
  }
  return false;
};

this.activeClass = function () {
  if (_this.pointIsActive()) {
    return 'active';
  }
  return '';
};

// update eyeball state w/ css only
this.updateActiveState = function () {
  if (!_this.refs) {
    return;
  }
  if (_this.pointIsActive()) {
    if (_this.refs.button && !_this.refs.button.classList.contains('active')) {
      _this.refs.button.classList.add('active');
    }
  } else {
    if (_this.refs.button && _this.refs.button.classList.contains('active')) {
      _this.refs.button.classList.remove('active');
    }
  }
};

this.getPointColor = function () {
  return _this.pointPerspective ? _this.pointPerspective.color : '#888';
};

this.showPerspectivePoint = function () {
  return _this.preview || _this.pointPerspective && !_this.pointPerspective.hidden;
};

this.pointIsActive = function () {
  if (_this.pointPerspective && pui.perspectiveIsPersistent(_this.pointPerspective.id)) {
    return true;
  }
  return false;
};
this.getPointPerspective = function () {
  return store.getPerspectives().find(function (p) {
    return p.pointNodeUUID == _this.node.id && !p.hidden;
  });
};
this.showPreviewEyeball = function (color) {
  _this.preview = true;
  _this.update();
  var eyeball = _this.refs.eyeball;

  if (eyeball) {
    eyeball.style.color = color;
  }
};
this.hidePreviewEyeball = function () {
  _this.unsetPreviewEyeball();
  var eyeball = _this.refs.eyeball;

  if (eyeball) {
    eyeball.style.color = '';
  }
};
this.unsetPreviewEyeball = function () {
  _this.preview = false;
  _this.update();
};

this.showEyebeams = function () {
  if (_this.canvas.linkDragging) return;
  var annotationTags = _this.canvas.perspectiveAnnotationTags[_this.pointPerspective.id];
  if (annotationTags) {
    for (var _iterator = Object.values(annotationTags), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _ref;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref = _i.value;
      }

      var annotationTag = _ref;

      if (!annotationTag.isMounted) continue;
      annotationTag.computeEyebeamPath();
      annotationTag.refs.eyebeam.classList.add('active');
      annotationTag.update();
    }
    _this.nodeTag.refs.container.classList.add('showing-eyebeams');
  }
  _this.hideNodeToolsTimeout = setTimeout(function () {
    _this.canvas.nodeTools.hide();
  }, 2000);
};

this.hideEyebeams = function () {
  if (_this.canvas.linkDragging) return;

  var annotationTags = _this.canvas.perspectiveAnnotationTags[_this.pointPerspective.id];
  if (annotationTags) {
    for (var _iterator2 = Object.values(annotationTags), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
      var _ref2;

      if (_isArray2) {
        if (_i2 >= _iterator2.length) break;
        _ref2 = _iterator2[_i2++];
      } else {
        _i2 = _iterator2.next();
        if (_i2.done) break;
        _ref2 = _i2.value;
      }

      var annotationTag = _ref2;

      if (!annotationTag.isMounted) continue;
      annotationTag.refs.eyebeam.classList.remove('active');
    }
    _this.nodeTag.refs.container.classList.remove('showing-eyebeams');
  }
  clearTimeout(_this.hideNodeToolsTimeout);
  _this.canvas.nodeTools.summon({
    node: _this.nodeTag,
    summonedFromChildNodes: false,
    positionReferenceElement: _this.nodeTag.refs.container
  });
};

this.setPointPerspective = function (perspective) {
  _this.pointPerspective = perspective;
};

this.freshen = function () {
  _this.pointPerspective = _this.getPointPerspective();
  _this.update();
};

this.handleRightClick = function (e) {
  if (!e.altKey) {
    e.preventDefault();
    e.stopPropagation();
    _this.canvas.rightClickMenu.summon({
      x: e.clientX,
      y: e.clientY,
      nodeEyeball: _this
    });
  }
};
this.needsBacking = function () {
  var instance = _this.nodeTag.instance;

  var style = instance.getDisplayStyle();

  if (style === 'accent') return true;

  var bg = instance.getBackgroundColor();

  if (!bg || bg == _constants.DEFAULTS.CARD_GRAY) {
    return false;
  }

  return true;
};

this.node = this.parent.instance;
this.pointPerspective = this.getPointPerspective();
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('node-eyeball')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/node-eyeball.html
// module id = 583
// module chunks = 0